import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Share1Stroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ReactNode } from 'react';
import { ActionButtonV2, type LineIconData } from '../action-button-v2';
import { FormMode } from '@/types/form';

export interface DocumentFormActionHandlersV2 {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onClose?: () => void;
  handleClose?: () => void;
  onPrint?: () => void;
  onSend?: () => void;
}

export interface DocumentFormActionOptionsV2 {
  showPrint?: boolean;
  showSend?: boolean;
  addIcon?: LineIconData;
  hideClose?: boolean;
  extraInfoActions?: ReactNode;
}

export const getDocumentFormActionButtonsV2 = (
  formMode: FormMode,
  activeTab: string,
  handlers: DocumentFormActionHandlersV2,
  options: DocumentFormActionOptionsV2 = {}
) => {
  const closeHandler = handlers.onClose ?? handlers.handleClose;

  if (formMode !== 'view') {
    return null;
  }

  if (activeTab === 'history') {
    return (
      <>
        <ActionButtonV2
          icon={RefreshCircle1ClockwiseStroke}
          title='Refresh'
          variant='secondary'
          onClick={() => console.log('refresh')}
        />
        <ActionButtonV2
          icon={SignPostLeftStroke}
          title='Cố định cột'
          variant='secondary'
          onClick={() => console.log('pin')}
        />
        {!options.hideClose && (
          <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' variant='secondary' onClick={closeHandler} />
        )}
      </>
    );
  }

  if (activeTab !== 'info') {
    return (
      <>
        <ActionButtonV2 icon={FloppyDisk1Stroke} title='Lưu' type='submit' />
        {!options.hideClose && <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={closeHandler} />}
      </>
    );
  }

  const AddIcon = options.addIcon ?? PlusStroke;

  return (
    <>
      {options.showPrint && (
        <ActionButtonV2 icon={PrinterStroke} title='In' onClick={handlers.onPrint ?? (() => console.log('In'))} />
      )}
      {options.showSend && (
        <ActionButtonV2
          icon={Share1Stroke}
          title='Gửi xử lý'
          onClick={handlers.onSend ?? (() => console.log('Send'))}
        />
      )}
      {options.extraInfoActions}
      <ActionButtonV2 icon={AddIcon} title='Thêm' onClick={handlers.onAdd} />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={handlers.onEdit} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={handlers.onDelete} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={handlers.onCopy} />
      {!options.hideClose && <ActionButtonV2 icon={ArrowLeftStroke} title='Đóng' onClick={closeHandler} />}
    </>
  );
};
